import { render, staticRenderFns } from "./remarkItem.vue?vue&type=template&id=215fa203"
import script from "./remarkItem.vue?vue&type=script&lang=js"
export * from "./remarkItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports